import { useMemo } from "react"
import { ConnectionHandler, useSubscription } from "react-relay"
import { graphql, GraphQLSubscriptionConfig } from "relay-runtime"
import { useMyChatAssignmentChangedSubscription as useMyChatAssignmentChangedSubscriptionType } from "@/modules/chats/services/__generated__/useMyChatAssignmentChangedSubscription.graphql"
import { ChatAppointmentConnectionKey } from "@/modules/chats/services/useChatAppointmentsQuery"

const myChatAssignmentChangedSubscription = graphql`
  subscription useMyChatAssignmentChangedSubscription($connections: [ID!]!) {
    myChatAssignmentChanged {
      takenByMe @prependNode(connections: $connections, edgeTypeName: "AppointmentEdge") {
        ...ChatAppointmentFragment @relay(mask: false)
      }
      removedFromMe {
        id @deleteEdge(connections: $connections)
        chatDetails {
          chatThreadId
        }
      }
    }
  }
`

export const useMyChatAssignmentChangedSubscription = (
  onChatRemovedFromMe?: (chatThreadId: string, appointmentId: string) => void,
) => {
  const subscriptionConfig: GraphQLSubscriptionConfig<useMyChatAssignmentChangedSubscriptionType> = useMemo(() => {
    const connection = ConnectionHandler.getConnectionID("client:root", ChatAppointmentConnectionKey)

    return {
      subscription: myChatAssignmentChangedSubscription,
      variables: { connections: [connection] },
      onNext: (res) => {
        const removedFromMe = res?.myChatAssignmentChanged.removedFromMe
        if (removedFromMe?.chatDetails?.chatThreadId) {
          onChatRemovedFromMe?.(removedFromMe.chatDetails.chatThreadId, removedFromMe.id)
        }
      },
      onError: console.log,
      cacheConfig: { metadata: { sensitive: true } },
    }
  }, [onChatRemovedFromMe])

  return useSubscription<useMyChatAssignmentChangedSubscriptionType>(subscriptionConfig)
}
